import classNames from 'classnames'
import type { FunctionComponent } from 'react'
import { useEffect, useState } from 'react'

import type { GreenHouseJob } from '../../server/helpers/greenhouse'
import styles from './greenhouse.module.scss'

const GREENHOUSE_SCRIPT_URL =
    'https://boards.greenhouse.io/embed/job_board/js?for=stepmobile'

// function to check if script is loaded
const isScriptLoaded = (src: string) => {
    return !!document.querySelector(`script[src="${src}"]`)
}

// function to sync load script if not loaded
const loadScript = (src: string) => {
    return new Promise((resolve) => {
        const script = document.createElement('script')
        script.src = src
        script.async = true
        script.onload = () => {
            resolve(true)
        }

        document.body.appendChild(script)
    })
}

export const GreenHouseForm: FunctionComponent<GreenHouseJob> = ({ id }) => {
    const [frameLoading, setFrameLoading] = useState(true)

    const init = async () => {
        if (!isScriptLoaded(GREENHOUSE_SCRIPT_URL)) {
            await loadScript(GREENHOUSE_SCRIPT_URL)
        }

        const loaded = window.Grnhse.Iframe.load(id)
        const element: HTMLIFrameElement = loaded.htmlElement
        element.addEventListener('load', () => setFrameLoading(false), true)
    }

    useEffect(() => {
        init()
    }, [])

    return (
        <div
            className={classNames(styles.form, {
                [styles['form-loading']]: frameLoading,
            })}
        >
            <div id='grnhse_app' />
        </div>
    )
}
